<template>
	<div class="header-notif">
		<app-tooltip :text="$t('notifications_label')">
			<template #activator>
				<button
					type="button"
					class="header-notif__btn"
					:aria-label="$t('notifications_label')"
					@click="onClick"
				>
					<app-icon
						name="burger"
						width="20px"
						height="20px"
						class="header-notif__icon"
					/>
					<span class="header-notif__counter">{{ count }}</span>
				</button>
			</template>
		</app-tooltip>

		<header-notifications-modal ref="$modal" />
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	onMounted,
	ref,
	watch
} from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import HeaderNotificationsModal from "./HeaderNotificationsModal.vue"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"

const store = headerStore()
const root = rootStore()
const $modal = ref<InstanceType<typeof HeaderNotificationsModal> | null>(null)

const count = computed(() => store.notificationCount.JobCount || 0)

const onClick = () => {
	$modal.value?.open()
}

defineExpose({ open: onClick })

onMounted(() => {
	if (root.globalJWT) {
		store.loadNotificationCount()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			store.loadNotificationCount()
			unwatch()
		}
	})
})
</script>

<style scoped>
.header-notif {
	position: relative;
}

.header-notif__btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background: transparent;
	border: none;
	color: #fff;
	cursor: pointer;
	padding: 4px 0;
	font-family: inherit;
	transition: color 0.15s ease;
}

.header-notif__btn:hover {
	color: #3F884F;
}

.header-notif__counter {
	color: inherit;
	font-size: 20px;
	font-weight: 600;
	line-height: 1;
}
</style>
